import React from 'react';

import DelayedAccessAlert, {
  Location
} from 'buyside/components/presentation/AccessControl/delayedAccessAlert';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import RelatedCompany from 'buyside/components/presentation/CompanyShowPage/RelatedCompany/relatedCompany';

import {
  useEntityRelatedCompaniesQuery,
  useMainNavigationCurrentUserQuery
} from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/CompanyShowPage/companyShowPageStyles.scss';

const EntityShowRelatedCompanies: React.FC<{ id: string; isPublic: boolean }> = ({
  id,
  isPublic
}): React.ReactElement => {
  const { data, loading, error } = useEntityRelatedCompaniesQuery({ variables: { id } });

  const {
    data: userData,
    loading: userLoading,
    error: userError
  } = useMainNavigationCurrentUserQuery({ skip: isPublic });

  if (loading || userLoading) return <LoadingSpinner size={SIZES.MEDIUM} />;

  if (error || userError) throw error;

  const canViewUserDetails = !isPublic && Boolean(userData?.currentUser?.canViewUserDetails);

  return (
    <div className={styles.accordionInner}>
      {data?.entity?.relatedCompanies?.length ? (
        <>
          <DelayedAccessAlert
            id={Location.entityRelatedCos}
            sectionName="idea results"
            isPublic={isPublic}
            customStyles={styles.alertPersistent}
          />
          {data.entity.relatedCompanies.map(entity => (
            <RelatedCompany
              entityWithIdea={entity}
              key={entity.id}
              showUserDetails={canViewUserDetails}
            />
          ))}
        </>
      ) : (
        <span className={styles.smallText}>None found</span>
      )}
    </div>
  );
};

export default EntityShowRelatedCompanies;
